import React, { useState } from 'react';

const DGFilterBar = ({ onFilterChange, initialFilters = {} }) => {
    const [filters, setFilters] = useState({
        searchTerm: initialFilters.searchTerm || '',
        startDate: initialFilters.startDate || '',
        endDate: initialFilters.endDate || '',
        status: initialFilters.status || '',
        involvedOnly: initialFilters.involvedOnly || false
    });

    // Removed internal user fetching as filtering logic moves to parent

    const handleChange = (key, value) => {
        const newFilters = { ...filters, [key]: value };
        setFilters(newFilters);
        onFilterChange(newFilters);
    };

    return (
        <div className="modern-card" style={{
            marginBottom: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end'
        }}>
            {/* Unified Search Input */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', flex: 1, minWidth: '200px' }}>
                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Search</label>
                <input
                    type="text"
                    placeholder="Search by Name, Email, Title, Division..."
                    value={filters.searchTerm || ''}
                    onChange={(e) => handleChange('searchTerm', e.target.value)}
                    className="modern-input"
                />
            </div>

            {/* Status Dropdown */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: '120px' }}>
                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Status</label>
                <select
                    value={filters.status || ''}
                    onChange={(e) => handleChange('status', e.target.value)}
                    className="modern-input"
                    style={{ padding: '0.4rem', height: '38px' }}
                >
                    <option value="">All Statuses</option>
                    <option value="Pending">Pending</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Completed">Completed</option>
                    <option value="Cancelled">Cancelled</option>
                </select>
            </div>

            {/* Date Range */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>From</label>
                <input
                    type="date"
                    value={filters.startDate}
                    onChange={(e) => handleChange('startDate', e.target.value)}
                    className="modern-input"
                />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>To</label>
                <input
                    type="date"
                    value={filters.endDate}
                    onChange={(e) => handleChange('endDate', e.target.value)}
                    className="modern-input"
                />
            </div>

            {/* Involved Only Checkbox */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem', minWidth: '140px' }}>
                <input
                    type="checkbox"
                    id="involvedOnly"
                    checked={filters.involvedOnly || false}
                    onChange={(e) => handleChange('involvedOnly', e.target.checked)}
                    style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                <label htmlFor="involvedOnly" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555', cursor: 'pointer', userSelect: 'none' }}>
                    My Involvement Only
                </label>
            </div>

            {/* Clear Filters */}
            <button
                onClick={() => {
                    const cleared = { searchTerm: '', startDate: '', endDate: '', status: '', involvedOnly: false };
                    setFilters(cleared);
                    onFilterChange(cleared);
                }}
                className="modern-button"
                style={{ background: '#e2e6ea', color: '#333' }}
            >
                Clear
            </button>
        </div>
    );
};

export default DGFilterBar;
